import { FC, useEffect } from "react"
import AnalysisTemplate from "components/layout/templates/analysisTemplate"
import UserListWrapper from "routes/analysis/users/components/userListWrapper"
import { useParams } from "react-router-dom"
import { LoaderWrapper } from "components/common/helpers"
import { AnalysisNavigator } from "routes/analysis/helpers/analysisHelpers"
import TransactionInfo from "./components/TransactionInfo";
import TestInfo from "./components/TestInfo";
import { ListType } from "routes/analysis/types/analysis"
import { Breadcrumb, BreadcrumbItem, } from "@appkit4/react-components"
import { useAtomValue } from "jotai"
import { filterAtom } from "jotai/store"
import { FetchAnalysisData } from "routes/analysis/queries/analysis"
import { FetchUserList } from "./queries/users"

const Users: FC<{ type: ListType }> = ({ type }) => {
  const { analysisId, testId, transactionId, roleId } = useParams();

  const userFilter = useAtomValue(filterAtom);

  const { data: analysisData, isPending: isAnalysisPending, error: errorAnalysis } = FetchAnalysisData(analysisId);

  const { data: userList, isPending: isUsersPending, error: errorUsers } = FetchUserList(analysisId, type, testId || transactionId || roleId || undefined, userFilter);

  const getRuleFunction = () => {
    let tempTests = userList?.tests
    if (tempTests)
      return tempTests[0].functions?.filter(f => f.functionId === userList?.transaction?.functionId)[0];
  }

  const ResultDetails = () => {
    if (!userList) return;
    switch (type) {
      case ListType.Test:
        return <TestInfo userList={userList} />
      case ListType.Transaction:
        return <TransactionInfo userList={userList} ruleFunction={getRuleFunction()} />
      default:
        return <h1>All users</h1>;
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  })
  return (
    <AnalysisTemplate>
      <LoaderWrapper loading={[isAnalysisPending, isUsersPending]} errors={[errorAnalysis, errorUsers]}>
      {
        userList && <Breadcrumb>
          <BreadcrumbItem>Analysis</BreadcrumbItem>
          <BreadcrumbItem>Users</BreadcrumbItem>
          {testId && <BreadcrumbItem>{userList?.test?.identifier}</BreadcrumbItem>}
          {transactionId && <BreadcrumbItem>{userList?.transaction?.identifier}</BreadcrumbItem>}
        </Breadcrumb>
      }
      <AnalysisNavigator />
        {
          ResultDetails()
        }
        {(userList && analysisData) && <UserListWrapper analysisData={analysisData} userList={userList} showMatch={testId === undefined && transactionId === undefined && roleId === undefined} />}
      </LoaderWrapper>
    </AnalysisTemplate>
  )
}



export default Users;
